import { StoreModule } from "@/constants/store.ts";
import { FilterContext } from "@/_store/filters.module";
import { createAllowBlockListStore } from "./msp-device-allow-block-list-factory.ts";

/**
 * Creates the store instance for the MSP EDR Allow/Block List.
 * It uses the factory with a specific configuration for the EDR feature.
 */
export const useMspEdrAllowBlockListStore = createAllowBlockListStore({
  id: StoreModule.MSP_EDR_ALLOW_BLOCK_LIST,
  filterContext: FilterContext.MSP_EDR_ALLOW_BLOCK_LIST_FILTERS,
  isEdr: true,
});
